import React, { useEffect, useState } from 'react';
import BaseContainer from "../BaseContainer"
import BaseButton from '../BaseButton'
import styles from './products.module.scss'
import IconComponent from '../icons';
import Categories from './Categories';
import H1 from "../Headings/H1";
import Filters from "./Filters";
import SearchBox from './SearchBox';
import NoResult from './NoResult';
import { checkActive } from '../../utils/helpers';

const Products = ({ data }) => {
  const { productItems, showText, hideText, showAllText, pageHeading, pageDescription, filterHeading, viewAllText, clearFilterText, applyFilterText,
    noResults, noResultsDescription, searchHeading, searchPlaceholder, productText, expertiseText } = data;
  const [toggleAll, setToggleAll] = useState(false);
  const [toggleFilterModal, setToggleFilterModal] = useState(false);
  const [viewAllDefault, setViewAllDefault] = useState(true);
  const [isResults, setIsResults] = useState(true);
  const [userInput, setUserInput] = useState("");
  const filterList = productItems && productItems.length && productItems.map((product, index) => {
    return ({ "title": product.title, isActive: false })
  })

  const storedObj = sessionStorage.getItem("filterList");
  const filterObj = storedObj ? JSON.parse(sessionStorage.getItem("filterList")) : filterList;
  const [filtersListData, setFilterListData] = useState(filterObj);
  const [prevFiltersListData, setPrevFilterListData] = useState(filterObj);


  const filtersListObj = filtersListData.filter((item, i) => {
    return item.isActive;
  })

  const ProductsObj = productItems.filter((product, i) => {
    return filtersListObj.every(checkActive) ? filtersListData[i].title === product.title : filtersListData[i].isActive && filtersListData[i].title === product.title;
  })

  const [firstExpertiseShown, setFirstExpertiseShown] = useState(false);

  const toggleExertiesExpantion = (data, value, flag) => {
    if (data) {
      return data.map((obj, index) => {
        return { ...obj, expertiesExpanded: flag && index === 0 && !firstExpertiseShown ? true :value }
      });
    }
  }

  const productData = storedObj ? ProductsObj : productItems;
  const [allProducts, setAllProducts] = useState(()=>toggleExertiesExpantion(productData,false));
  useEffect(() => {
    if (sessionStorage.getItem("searchedProducts") !== null) {
      setToggleAll(true);
      if (sessionStorage.getItem("searchedProducts") === "") {
        setIsResults(false)
      }
    }
  }, [])

  const setDefaultHideExpertiesExpantion = (index) => {
    const allProductsList = allProducts.map((obj, idx) => {
      if (idx === index) {
        return { ...obj, expertiesExpanded: !obj.expertiesExpanded }
      }
      return { ...obj }
    })
    setAllProducts(allProductsList);

    const expertiesExpanded = allProductsList.filter((obj) => obj.productCategory?.length > 0)?.every(obj => obj.expertiesExpanded === true);
   
    setToggleAll(expertiesExpanded);
  }

  useEffect(() => {
  }, [filtersListData])
  const renderProductItems = () => {
    return allProducts && allProducts.map((product, index) => {
      return (
        <section className="bg-white rounded-lg mb-4 last:mb-0 relative" key={`product-list${index}`} id={`product-list-${index}`}>
          <div className="relative flex flex-col lg:flex-row gap-5 p-5 pb-[15px]">
            <picture className="lg:w-[95px] lg:h-[92px] grow-1">
              <source media="(min-width: 1024px)" srcSet={product.desktopImage} />
              <source media="(max-width: 1023px)" srcSet={product.mobileImage} />
              <img src={product.desktopImage} alt={product.title} className="rounded-lg object-cover object-center w-full h-full" loading="lazy" />
            </picture>
            <div className="grow shrink basis-0">
              <h4 className="text-[21px] leading-[27.3px] lg:text-2xl font-semibold text-black">{product.title}</h4>
              <div className={`my-4 lg:my-2 text-sm lg:text-base font-normal text-ek-grey-500 tracking-[0.56px] h-[42px] lg:h-[22px] ${styles.desc}`} dangerouslySetInnerHTML={{ __html: product.description }}></div>
              {product.linkTitle && (
                <BaseButton title={product.linkTitle} href={product.linkHref} type="tertiary" target={product.linkTarget} size="small" className="!text-sm tracking-[1.4px] !p-[0px]" icon="arrow-right" iconClassName="w-[28px] h-[12px]"></BaseButton>
              )}
            </div>
          </div>
          <Categories index={index} expertiesExpanded={product.expertiesExpanded} setDefaultHideExpertiesExpantion={setDefaultHideExpertiesExpantion} categories={product.productCategory} showText={showText} hideText={hideText} ourExpertiseText={product.ourExpertiseText} toggleAll={toggleAll} setToggleAll={setToggleAll} hightlightCategories={hightlightCategories}  />
        </section>
      )
    })
  }


  const hightlightCategories = (val) => {
    const searchCategoryVal = sessionStorage.getItem("searchedCategories") !== null ? sessionStorage.getItem("searchedCategories") : "";
    const searchProductVal = sessionStorage.getItem("searchedProducts") !== null ? sessionStorage.getItem("searchedProducts") : "";
    const isProductSearch = searchProductVal.toLowerCase().indexOf(searchCategoryVal.toLowerCase()) !== -1
    if (isProductSearch) {
      return searchProductVal.toLowerCase().indexOf(searchCategoryVal.toLowerCase()) !== -1;
    }
    else {
      return searchCategoryVal === "" || val.toLowerCase().includes(searchCategoryVal.toLowerCase())
    }
  }

  const toggleshowAllExpertise = () => {
    setToggleAll(!toggleAll);
    const allProductsList = allProducts.map((obj) => {
      return { ...obj, expertiesExpanded: !toggleAll }
    })
    setAllProducts(allProductsList);
    setFirstExpertiseShown(true);
  }

  const rendershowAllExperties = () => {
    return (
      <span onClick={toggleshowAllExpertise} className='flex items-center cursor-pointer text-[14px] h-[21px]'>
        <IconComponent icon={toggleAll ? 'checkbox-checked' : "checkbox"} className={`mr-2 text-ek-red`} />
        {showAllText}
      </span>
    )
  }

  const renderHead = () => {
    return (
      <div className="pb-3 lg:pb-7">
        {pageHeading && (
          <span className="text-xs font-bold text-ek-red tracking-[4.8px]">{pageHeading}</span>
        )}
        {pageDescription && (
          <H1>{pageDescription}</H1>
        )}
      </div>
    )
  }

  const toggleFilterItems = (FilterActive, FilterIndex) => {
    filtersListData && filtersListData.length && filtersListData.forEach((item, index) => {
      if (index === FilterIndex) {
        item.isActive = FilterActive;
      }
    })
    sessionStorage.setItem("filterList", JSON.stringify(filtersListData));
    setFilterListData(JSON.parse(sessionStorage.getItem("filterList")));
  }

  const applyFilters = (type, value, active, index) => {
    setViewAllDefault(false);
    toggleFilterItems(active, index);
    const filterData = productItems.filter((product, i) => {
      return filtersListData[i].isActive && filtersListData[i].title === product.title;
    });

    filterData.length ? setAllProducts(toggleExertiesExpantion(filterData, toggleAll, true)) : setAllProducts(toggleExertiesExpantion(productItems, toggleAll, true));

    handleSearchStorage(false);
    setUserInput("");
  }

  const clearFilters = (type, value, active, index) => {
    setViewAllDefault(false);
    toggleFilterItems(active, index);
    const filterData = productItems.filter((product, i) => {
      return filtersListData[i].isActive && filtersListData[i].title === product.title;
    })
    filterData.length ? setAllProducts(toggleExertiesExpantion(filterData, toggleAll, true)) : setAllProducts(toggleExertiesExpantion(productItems, toggleAll, true));
    handleSearchStorage(false);
    setUserInput("")
  }


  const clearAllFilters = () => {
    setViewAllDefault(true);
    const ClearAllfilterList = productItems && productItems.length && productItems.map((product) => {
      return ({ "title": product.title, isActive: false })
    })
    setFilterListData(ClearAllfilterList);
    sessionStorage.removeItem("filterList");
    handleSearchStorage(false);
    setAllProducts(productItems);
    setIsResults(true);
    setToggleAll(false);
    setUserInput("");
    setFirstExpertiseShown(false)
  }

  const viewAllFilters = (flag) => {
    setViewAllDefault(false);
    const viewAllfilterList = productItems && productItems.length && productItems.map((product) => {
      return ({ "title": product.title, isActive: flag ? true : false })
    })
    sessionStorage.setItem("filterList", JSON.stringify(viewAllfilterList));
    setFilterListData(JSON.parse(sessionStorage.getItem("filterList")));
    setAllProducts(toggleExertiesExpantion(productItems, toggleAll));
    handleSearchStorage(false);
    setUserInput("")
  }

  const handleFilters = (type, value, active, index) => {
    switch (type) {
      case 'APPLY': applyFilters(type, value, active, index);
        break;
      case 'CLEAR': clearFilters(type, value, active, index);
        break;
      default: break;
    }
  }

  const toggleFilter = (val) => {
    setToggleFilterModal(val)
  }

  const renderSelectedItems = () => {
    if (filtersListData && filtersListData.length) {
      return filtersListData.map((item, index) => {
        return (
          <span onClick={(event) => { event.stopPropagation(); handleFilters("CLEAR", item.title, !item.isActive, index) }} key={`selected-filter-${index}`} className={`relative inline-flex items-center text-white text-xs leading-[18px] tracking-[.24px] h-[30px] pr-9 pl-2 py-2 rounded-lg bg-ek-grey-500 ${item.isActive ? "" : "hidden"}`}>
            {item.title}
            <span className="px-2 h-full absolute right-0 top-0 flex items-center"><IconComponent icon="close-circle" className="text-ek-grey-300" /></span>
          </span>
        )
      })
    }
  }

  const handleSearchStorage = (flag, productTitle, categoryTitle) => {
    if (flag) {
      sessionStorage.setItem("searchedProducts", productTitle)
      sessionStorage.setItem("searchedCategories", categoryTitle)
    }
    else {
      sessionStorage.removeItem("searchedProducts");
      sessionStorage.removeItem("searchedCategories");
    }
  }

  const handleResultsOnSearch = (productTitle, categoryTitle, filterType) => {
    setPrevFilterListData(filtersListData)
    clearAllFilters();
    handleSearchStorage(true, productTitle, categoryTitle);
    const updateResultData = productItems && productItems.length && productItems.map((product) => {
      return ({ "title": product.title, isActive: productTitle.includes(product.title) ? true : false })
    })

    const filterObj = productItems.filter((product, i) => {
      return productTitle.includes(product.title);
    })
    setAllProducts(toggleExertiesExpantion(filterObj, true));

    sessionStorage.setItem("filterList", JSON.stringify(updateResultData));
    setFilterListData(JSON.parse(sessionStorage.getItem("filterList")));
    setToggleAll(true);

    const activeObj = [];
    updateResultData.map((item) => {
      return activeObj.push(item.isActive);
    })
    setIsResults(activeObj.some(checkActive))

  }

  const handleSearchClose =()=>{
    clearAllFilters();
    sessionStorage.setItem("filterList", JSON.stringify(prevFiltersListData));
    setFilterListData(prevFiltersListData);
    const prevFilterData = productItems.filter((product, i) => {
      return prevFiltersListData[i].isActive && prevFiltersListData[i].title === product.title;
    })
    prevFilterData.length ? setAllProducts(toggleExertiesExpantion(prevFilterData, false, true)) : setAllProducts(toggleExertiesExpantion(productItems, false, true));

  }

  return (
    <BaseContainer className='mt-[40px] lg:mt-[80px] mb-[40px] lg:mb-[80px]'>
      {renderHead()}
      <div className="lg:hidden pb-4 text-sm text-333 leading-[21px] tracking-[.56px]">
        <div className="font-bold mb-1">{filterHeading}</div>
        <div className="bg-white flex items-center justify-between py-[10px] px-[15px] rounded-[7px] border border-ek-grey-200 min-h-[42px] cursor-pointer" onClick={() => { toggleFilter(true) }}>
          <div className="flex flex-wrap gap-2">
            {filtersListObj.every(checkActive) ? viewAllText : renderSelectedItems()}
          </div>
          <div className="w-5 h-5 flex items-center justify-center"><IconComponent icon="chevron-slim" className="chevron-slim relative text-ek-red rotate-90" /></div>
        </div>
      </div>
      <div className="flex justify-between">
        <div className={`${toggleFilterModal ? "" : "hidden"} lg:block w-full lg:w-[25%] xl:w-[calc(100%-786px)] 2xl:w-[calc(100%-806px)]`}>
          <div className="fixed rounded-t-lg w-full left-0 bottom-0 lg:bottom-auto bg-white lg:bg-transparent z-50	lg:z-0 lg:relative">
            <Filters data={filtersListData} pageHeading={pageHeading} filterHeading={filterHeading} viewAllText={viewAllText} clearFilterText={clearFilterText} applyFilterText={applyFilterText} handleFilters={handleFilters} viewAllFilters={viewAllFilters} clearAllFilters={clearAllFilters} toggleFilter={toggleFilter} viewAllDefault={viewAllDefault} setViewAllDefault={setViewAllDefault}/>
          </div>
          <div className="fixed inset-x-0 z-40 top-0 left-0 w-full h-full bg-black/50 backdrop-blur-[5px] lg:hidden"></div>
        </div>
        <div className="w-full lg:w-[75%] xl:lg:w-[786px] 2xl:lg:w-[806px]">
          <div className="flex justify-between gap-4 lg:gap-5 flex-col lg:flex-row pb-6">
            <div className='lg:flex-1'>
              {
                <SearchBox data={allProducts} noResults={noResults} searchHeading={searchHeading} searchPlaceholder={searchPlaceholder} handleResultsOnSearch={handleResultsOnSearch} userInput={userInput} setUserInput={setUserInput} productText={productText} expertiseText={expertiseText} clearAllFilters={clearAllFilters} handleSearchClose={handleSearchClose}  />
              }
            </div>
            {isResults && <div className="lg:self-end lg:pr-4 lg:mb-4">
              {rendershowAllExperties()}
            </div>}
          </div>
          {!isResults && <NoResult title={noResults} description={noResultsDescription} />}
          {isResults && renderProductItems()}
        </div>
      </div>
    </BaseContainer>
  )
}

export default Products;